"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hospiceCRCostOfCare = {
    name: 'hospice-cost-report-cost-of-care',
    tableType: 'fact',
    grain: [
        'facility::key',
        'year::key',
    ],
    tableGrain: [
        '!facility',
        'year_key',
    ],
    foreignKeys: [
        'facility::key'
    ],
};
const hospiceCRDays = {
    name: 'hospice-cost-report-days',
    tableType: 'fact',
    grain: [
        'facility::key',
        'year::key',
    ],
    tableGrain: [
        '!facility',
        'year_key',
    ],
    foreignKeys: [
        'facility::key'
    ],
};
const hospiceCRRevenue = {
    name: 'hospice-cost-report-revenue',
    tableType: 'fact',
    grain: [
        'facility::key',
        'year::key',
    ],
    tableGrain: [
        '!facility',
        'year_key',
    ],
    foreignKeys: [
        'facility::key'
    ],
};
const hospiceCRSalaries = {
    name: 'hospice-cost-report-salaries',
    tableType: 'fact',
    grain: [
        'facility::key',
        'year::key',
    ],
    tableGrain: [
        '!facility',
        'year_key',
    ],
    foreignKeys: [
        'facility::key'
    ],
};
exports.default = [
    hospiceCRCostOfCare,
    hospiceCRDays,
    hospiceCRRevenue,
    hospiceCRSalaries,
];
